// extracted by mini-css-extract-plugin
export var badge = "_sx-4";
export var selected = "_sx-1";
export var selectedOverlay = "_sx-5";
export var thumbnailButton = "_sx-0";
export var thumbnailFallback = "_sx-3";
export var thumbnailImage = "_sx-2";